// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format5 } from '../../constants';

/** Kosovo */
const XK: PhoneNumberData = [383, 'XK', 8, format5];

export default XK;
